import React, { useEffect, useState } from "react";
import { TextInput } from "@mantine/core";
import {
  formatDecimalHoursToTime,
  parseDurationToDecimalHours,
} from "../components/InstructorForm";

interface Props {
  /** Decimal hours as stored (e.g. "16.92") */
  value: string;
  /** Called with decimal hours as a string whenever the typed text is valid */
  onChange: (decimalHours: string) => void;
}

/**
 * Lets admins type attended hours as "16h 55m" (or "16:55" / "16.92") while
 * the value kept in state — and saved — is decimal.
 */
const AttendedHoursInput: React.FC<Props> = ({ value, onChange }) => {
  const [text, setText] = useState(formatDecimalHoursToTime(value) || "");
  const [focused, setFocused] = useState(false);

  useEffect(() => {
    if (!focused) setText(formatDecimalHoursToTime(value) || "");
  }, [value, focused]);

  const parsed = parseDurationToDecimalHours(text);
  const invalid = text.trim() !== "" && parsed === null;

  return (
    <TextInput
      label="Attended Hours"
      placeholder="e.g. 16h 55m"
      value={text}
      onFocus={() => setFocused(true)}
      onBlur={() => setFocused(false)}
      onChange={(e) => {
        const next = e.target.value;
        setText(next);
        const p = parseDurationToDecimalHours(next);
        if (p !== null) onChange(String(p));
      }}
      error={invalid ? 'Use "16h 55m", "16:55" or "16.92"' : undefined}
      description={parsed !== null ? `Saved as ${parsed} hrs` : undefined}
      styles={{
        input: { fontSize: "0.75rem" },
        label: { fontSize: "0.7rem", fontWeight: 600 },
        description: { fontSize: "0.65rem" },
      }}
    />
  );
};

export default AttendedHoursInput;
